import React, { useContext, useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog"
import { UserCtx } from "../context/userContext"

const NewFeature: React.FC = () => {
  const { user } = useContext(UserCtx)
  const [showModal, setShowModal] = useState<boolean>(false)

  useEffect(() => {
    const showNewFeature = localStorage.getItem("showNewFeature") === "false"
    if (!showNewFeature) {
      setShowModal(true)
      localStorage.setItem("showNewFeature", "true")
    }
  }, [])

  const handleOpenChange = (open: boolean) => {
    setShowModal(false)
    localStorage.setItem("showNewFeature", "false")
  }

  const first_name = user?.firstName

  return (
    <>
      <Dialog open={showModal} onOpenChange={handleOpenChange}>
        <DialogContent className="w-full max-w-2xl max-h-screen overflow-y-auto">
          {" "}
          <DialogHeader>
            <DialogTitle className="text-center mb-4 text-2xl">
              {"\u2728"} Announcement: Calendar Settings Upgraded!{" "}
            </DialogTitle>
            <DialogDescription className="text-center text-lg space-y-4">
              <p>
                {first_name ? `Hey ${first_name}! ` : "Hey there! "}
                We've restructured and upgraded your Calendar Settings.
              </p>
              <p>
                Coaches can now easily add out-of-office hours, view
                availability in editable cards, and manage scheduling more
                efficiently.
              </p>
              <p>
                We've also added the option to turn availability off, giving
                coaches complete control over client scheduling. More exciting
                features are coming soon!
              </p>
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default NewFeature
